import axios from "axios";
import { checkTokenExpirationIC } from "services/apiIC";
import { checkTokenExpiration } from "contexts/TokenCheck";
import { BASE_URL_API } from "constants/constants";

export async function logInICAPI(data) {
  const token = await checkTokenExpiration();

  return axios.post(BASE_URL_API + "login-get-token-ic", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function getLiveChatTemplateICAPI(data) {
  const token = await checkTokenExpiration();

  return axios.post(BASE_URL_API + "ic/get-live-chat-template", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function updateLiveChatTemplateICAPI(data) {
  const token = await checkTokenExpiration();

  return axios.post(BASE_URL_API + "ic/update-live-chat-template", data, {
    headers: {
      Authorization: token,
    },
  });
}

export function refreshTokenICAPI(data) {
  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/auth/refresh-token",
    data,
    {
      headers: {
        Authorization:
          "Bearer " + localStorage.getItem("icIntegration_accessToken"),
      },
    }
  );
}

export async function getUserICAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/user/get-information",
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getChatBotICAPI() {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/chat-bot-new/get-all",
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getAllUserICAPI() {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/user/get-all-user-state-not-report-to",
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getListMessagesICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction/get-list-interaction-by-view-type",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function updateStatusICCRMAPI(data) {
  const token = await checkTokenExpiration();

  return axios.post(BASE_URL_API + "user-management/set-status/ic", data, {
    headers: {
      Authorization: token,
    },
  });
}

export async function updateStatusICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/user/update-state",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getStatusICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/user/get-user-state",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getStateListICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/state-list/get-all",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getTagsICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-tag/get-all",
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function addTagICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-tag/add-tag-to-interaction",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function deleteTagICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-tag/delete-in-interaction",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function createTagICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-tag/create",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getMessageDetailsICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail/get-list-interaction-detail",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getMessageInternalDetailsICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/get-list-interaction-detail",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function disableBotICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/agent-conversation/unlock-conversation",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function sendMessageICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/distribution/send-mess",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function sendInternalMessageICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/send-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function completeConversationICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/agent-conversation/close-conversation",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function uncompleteConversationICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/agent-conversation/uncomplete-conversation",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function resgisterSignalrICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "notification/api/signalr/register",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function registerConnectionIntervalICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "notification/api/signalr/register-interval",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getQuickMessagesICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/message-template/get-all-chat",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getUserStateICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "user/api/user/get-list-user-state",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getInteractionMemberICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactionmember/get-list-interaction-member",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function addAgentICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/agent-conversation/add-agent",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function transferAgentICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/agent-conversation/transfer",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getIndexMessageICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail/get-index-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getIndexMessageInternalICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/get-index-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getFacebookPostICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "social-connection/api/social-custom/get-facebook-post",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getListSocialRegisterICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/social-register/get-all",
    {},
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getEmailDetailsICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "email/api/email-data/get-details-from-ids",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function disconnectSignalRICAPI(data) {
  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "notification/api/signalr/disconnect",
    data,
    {
      headers: {
        PUBLIC_KEY:
          "TA7RKZPWQV8XBTIZOPO5HUEYAK8EJK34UFU2HFMNCR3D2ADJE8GHTPFK8NUTM5ASFWCAYTAHEE",
      },
    }
  );
}

export async function reconnectSignalRICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "notification/api/signalr/register-interval",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getEmailSettingICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "email/api/email-setting/get-all",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getSocialRegisterICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/social-register/get-all",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getInternalMessagesICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-internal/get-list-interaction",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function addGroupICAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-member-internal/add-member-to-interaction",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function removeGroupMemberAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-member-internal/remove-member-to-interaction",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getProductListAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/product/get-all-for-livechat",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getCustomerAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/customer/get-by-id",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getMemberListAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-member-internal/get-list-member",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getUserByIdAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") + "user/api/user/get-by-id",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function leaveGroupAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-member-internal/leave-group",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getBackChatAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction-member-internal/back-chat",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getButtonsIntegrationAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "settings/api/button-integration/get-all-details",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function updateInteractionStateAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interaction/update-interaction-state",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function facebookLikeCommentAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "social-connection/api/social-custom/facebook-like-comment",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function facebookHideCommentAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "social-connection/api/social-custom/facebook-hide-comment",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function facebookRemoveCommentAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "social-connection/api/social-custom/facebook-remove-comment",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function sendMessDirectCustomerAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "conversation-session/api/distribution/send-mess-direct-customer",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function forwardMessageAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/forward-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function messageRecallAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/message-recall",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function updateMessageAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/update",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function pinMessageAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/pin-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function unpinMessageAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/delete-pin-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}

export async function getListPinMessageAPI(data) {
  const token = await checkTokenExpirationIC();

  return axios.post(
    localStorage.getItem("icIntegration_link_api") +
      "idstore/api/interactiondetail-internal/get-list-pin-message",
    data,
    {
      headers: {
        Authorization: "Bearer " + token,
      },
    }
  );
}
